export default __webpack_public_path__ + "static/mightyC@2x-0f5e1a12e151a483b5acf20c314b675f.jpg";